// if (!customElements.get('sticky-atc-panel')) {
//   class StickyAtcPanel extends HTMLElement {
//     constructor() {
//       super();

//       this.productSection = this.closest('.cc-main-product');
//       this.productInfo = this.productSection.querySelector('.product-info');
//       this.productForm = this.productSection.querySelector('product-form');

//       if ('IntersectionObserver' in window && 'MutationObserver' in window) {
//         this.bindEvents();
//       }
//     }

//     // eslint-disable-next-line class-methods-use-this
//     disconnectedCallback() {
//       window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
//     }

//     bindEvents() {
//       const observer = new IntersectionObserver((entries) => {
//         entries.forEach((entry) => {
//           console.log(entry.target);
//           if (entry.target === this.productForm && !theme.mediaMatches.md) {
//             console.log(12);
//             this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
//           } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
//             console.log(1212);
//             this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
//           }
//         });
//       });

//       if (this.productForm) observer.observe(this.productForm);
//       if (this.productInfo) observer.observe(this.productInfo);

//       window.addEventListener('scroll', StickyAtcPanel.handleScroll);
//     }

//     /**
//      * Watches for a scroll to the bottom of the page
//      */
//     static handleScroll() {
//       document.body.classList.toggle(
//         'scrolled-to-bottom',
//         window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
//       );
//     }
//   }

//   customElements.define('sticky-atc-panel', StickyAtcPanel);
// }


if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productForm = this.productSection?.querySelector('product-form');

      this.handleVisibility = this.handleVisibility.bind(this);

      if (this.productForm) {
        window.addEventListener('scroll', this.handleVisibility);
        this.handleVisibility(); // initial check
      }

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleVisibility);
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    handleVisibility() {
      const calculatorWrapper = document.querySelector('.custom-size-calculator-wrapper');
      const calculatorOpen = calculatorWrapper?.classList.contains('open');

      if (!this.productForm || calculatorOpen) {
        this.classList.add('sticky-atc-panel--out'); // hide sticky
        return;
      }

      const formRect = this.productForm.getBoundingClientRect();

      // form top above viewport top => show sticky
      const formTopAboveViewport = formRect.top <= 0;

      // toggle sticky: show only if top of form is above viewport AND calculator is closed
      this.classList.toggle('sticky-atc-panel--out', !formTopAboveViewport);
    }

    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 >= document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
// Main Atc button trigger

// document.addEventListener('DOMContentLoaded', function () {
//   const stickyBtn = document.querySelector('.sticky-atc-btn');
//   if (!stickyBtn) return;

//   stickyBtn.addEventListener('click', function () {
//     // Find main product form's Add to Cart button
//     const mainAtcBtn = document.querySelector('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]');
//     if (mainAtcBtn) {
//       mainAtcBtn.click(); // trigger main Add to Cart
//     } else {
//       console.warn('Main Add to Cart button not found');
//     }
//   });
// });


document.addEventListener('DOMContentLoaded', function () {
  const stickyBtn = document.querySelector('.sticky-atc-btn');
  if (!stickyBtn) return;

  stickyBtn.addEventListener('click', function (e) {
    e.preventDefault();

    // Add loading state
    stickyBtn.classList.add('loading');
    stickyBtn.disabled = true;
    const originalText = stickyBtn.innerHTML;
    stickyBtn.innerHTML = `<span class="spinner"></span> Adding...`;

    // Find main Add to Cart button
    const mainAtcBtn = document.querySelector('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]');
    if (mainAtcBtn) {
      mainAtcBtn.click();

      // Wait until cart is updated (basic fallback)
      document.addEventListener('shopify:section:load', resetStickyBtn, { once: true });
      setTimeout(resetStickyBtn, 3000); // fallback reset after 3s
    } else {
      console.warn('Main Add to Cart button not found');
      resetStickyBtn();
    }

    function resetStickyBtn() {
      stickyBtn.innerHTML = originalText;
      stickyBtn.classList.remove('loading');
      stickyBtn.disabled = false;
    }
  });
});

